import { defineMessages } from '@formatjs/intl';

const messages = defineMessages({
	trialPhraseDays: {
		id: 'campaign.page.offer.trialPhraseDays',
		defaultMessage: 'a {length, plural, one {#-day} other {#-day}} trial',
		description: 'Free trial length in days, composed into the campaign offer summary',
	},
	trialPhraseMonths: {
		id: 'campaign.page.offer.trialPhraseMonths',
		defaultMessage: 'a {length, plural, one {#-month} other {#-month}} trial',
		description: 'Free trial length in months, composed into the campaign offer summary',
	},
	offerTrialAndDiscount: {
		id: 'campaign.page.offer.trialAndDiscount',
		defaultMessage: '{trialPhrase} and {discountPercent}% off',
		description: 'Campaign offer summary combining a free trial and a percent-off discount',
	},
	offerDiscountOnly: {
		id: 'campaign.page.offer.discountOnly',
		defaultMessage: '{discountPercent}% off',
		description: 'Campaign offer summary for a percent-off discount with no free trial',
	},
	offerNone: {
		id: 'campaign.page.offer.none',
		defaultMessage: 'full access',
		description: 'Campaign offer summary when there is neither a free trial nor a discount',
	},
	missingCodeErrorHeading: {
		id: 'campaign.page.error.missingCode.heading',
		defaultMessage: 'This offer isn’t available',
		description: 'Heading shown when a paid campaign has no redemption code to purchase with',
	},
	missingCodeErrorSubheading: {
		id: 'campaign.page.error.missingCode.subheading',
		defaultMessage:
			'This link is missing the code needed to redeem this offer. Please use the original link you were given.',
		description: 'Subheading shown when a paid campaign has no redemption code to purchase with',
	},
});

export default messages;
